/* global window, videojs */

import youbora from 'youboralib';
import VideojsAdapter from 'youbora-adapter-videojs';
import get from 'lodash/get';

/**
 * Class representing an Youbora plugin.
 */
class Youbora {
  /**
   * Create an Youbora plugin.
   */
  constructor() {
    this.accountCode = window.LUMIERE_YOUBORA_ACC_CODE || 'hearst';
  }

  /**
  * Attach Youbora plugin to player.
  * @param {Object} player - A VideoJS player object.
  * @param {Boolean} isLive - Is live stream.
  * @param {String} adTag - Ad tag.
  * @param {Array} src - Content sources.
  */
  attachPlayer(player, isLive, adTag, src) {
    const youboraOptions = {
      accountCode: this.accountCode,
      enabled: true,
      'parse.hls': true,
      'content.isLive': isLive,
    };

    if (get(window, 'HRST.site.prefix')) {
      youboraOptions['extraparam.1'] = window.HRST.site.prefix;
    }

    if (adTag) {
      youboraOptions['extraparam.2'] = adTag;
    }

    if (src && src.length > 0) {
      let index = 3;
      src.forEach(item => {
        youboraOptions[`extraparam.${index++}`] = item;
      });
    }

    const youboraPlugin = new youbora.Plugin(youboraOptions);
    const adapter = new VideojsAdapter(player);

    if (youboraPlugin && adapter) {
      youboraPlugin.setAdapter(adapter);
      videojs.log(`${player.id()} youbora plugin initialized`);
    } else {
      videojs.log.error(`${player.id()} youbora plugin not ready`);
    }
  }
}

export default Youbora;



// WEBPACK FOOTER //
// ./src/Youbora.js